import { defineStore } from 'pinia'
import { type IApiInstance } from '../plugins/api'

export type IMonitorsState = {
  isLoaded: boolean
  monitors: any[]
}

export const useMonitorsStore = defineStore('monitors', {
  state: (): IMonitorsState => {
    return {
      isLoaded: false,
      monitors: [],
    }
  },
  getters: {
    getMonitorById: (state) => (id: string) => {
      return state.monitors.find((t: any) => t.id === id)
    },
  },
  actions: {
    async load() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance
      const { ENVIRONMENT } = useEnvironment()
      const monitorFilterEnv: any = {
        production: ['production'],
        staging: ['production', 'staging'],
        develop: ['production', 'staging', 'develop'],
      }
      const monitors = (
        await api.cms.get(
          'monitors',
          `fields[]=*&fields[]=translations.*&fields[]=alerts.*&fields[]=alerts.conditions.*&fields[]=alerts.translations.*&limit=300&filter[status][_in]=${monitorFilterEnv[ENVIRONMENT]}`,
        )
      ).data

      if (monitors) {
        this.$patch({ isLoaded: true, monitors })
      }
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
